import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { useGetCurrentCompFilters } from 'common/react/components/competition-nav/hooks/use-get-current-comp-filters';
import { FixturesNav } from './FixturesNav';
import { FixturesList } from './fixtures-list/FixturesList';
import { FixturesSkeleton } from './fixtures-list/FixturesSkeleton';
import { EmptyState } from 'common/react/components/EmptyState';
import { useGetAllContentQuery } from 'common/store/modules/api/content-api';

export const Fixtures = (data) => {
    const { competitionId, competitionPid, compSeason, round, roundLoadError } =
        useGetCurrentCompFilters();

    const [scrollToRound, setScrollToRound] = useState(null);

    // contents param should be in format ?contents=PROMO:{reference},PROMO:{reference}
    const broadcasterPromoIds = data?.broadcasterPromos
        ?.split(',')
        .map((id) => `PROMO:${id}`);

    const { data: broadcasterPromoData = [] } = useGetAllContentQuery(
        {
            params: {
                contents: broadcasterPromoIds?.join(',')
            }
        },
        { skip: !broadcasterPromoIds }
    );

    const broadcasterPromo = useMemo(() => {
        const found = broadcasterPromoData.find((promo) => {
            let compReference = promo.references?.find(
                (ref) =>
                    ref.type === 'AFL_COMPETITION' && ref.id === competitionId
            );
            return typeof compReference !== 'undefined';
        });

        return found;
    }, [broadcasterPromoData, competitionId]);

    const roundNumber = Number(round?.roundNumber);
    const isLoading = !competitionId || !compSeason?.id || isNaN(roundNumber);
    if (roundLoadError) {
        return (
            <>
                <FixturesNav {...data} onRoundClick={setScrollToRound} />
                <div className="wrapper">
                    <EmptyState cssClass="competition-nav__empty-state" />
                </div>
            </>
        );
    }

    if (isLoading) {
        return (
            <>
                <FixturesNav {...data} onRoundClick={setScrollToRound} />
                <div className="wrapper">
                    <FixturesSkeleton />
                </div>
            </>
        );
    }

    return (
        <>
            <FixturesNav {...data} onRoundClick={setScrollToRound} />
            <div className="wrapper">
                <FixturesList
                    competitionId={competitionId}
                    competitionPid={competitionPid}
                    compSeason={compSeason}
                    roundNumber={roundNumber}
                    broadcasterPromo={broadcasterPromo}
                    scrollToRound={scrollToRound}
                    setScrollToRound={setScrollToRound}
                    round={round}
                />
            </div>
        </>
    );
};

Fixtures.propTypes = {
    data: PropTypes.object
};
